import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import Home from './views/Home.vue'
import Blog from './views/Blog.vue'
import BlogList from './views/BlogList.vue'
import Admin from './views/Admin.vue'
import './assets/main.css'
import './style.css'
import '@mdi/font/css/materialdesignicons.css'

// 获取基础路径
// 如果部署在子目录，可以在这里设置
// 例如，如果部署在 https://example.com/fcsgroup/，则设置为 '/fcsgroup/'


// 创建路由 - 使用哈希模式
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/blog/:name',
    name: 'Blog',
    component: Blog
  },
  {
    path: '/blog',
    name: 'BlogList',
    component: BlogList
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 创建应用
const app = createApp(App)

// 使用路由
app.use(router)

// 挂载应用
app.mount('#app') 